import Header from './Header/Header';
import Footer from './Footer/Footer';
import EmptyPlaceholder from './EmptyPlaceholder/EmptyPlaceholder';
import UploadsList from './UploadsList/UploadsList';
import WatchingStateSection from './WatchingStateSection/WatchingStateSection';
import useAssetUploadsBox from './useAssetUploadsBox';

import './AssetUploadsBox.scss';

export type AssetUploadsBoxProps = {
	projectID?: number,
	folderID?: number | null
};

const AssetUploadsBox = ( {
	projectID, folderID = null
}: AssetUploadsBoxProps ) => {
	const {
		uploadProjectIDs,
		assetActiveUploadsCount,
		totalTimeRemaining,
		totalProgress,
		hasUploads,
		isUploading,
		canUploadItems,
		onStartUploadClicked,
		onCancelAllClick,
		onClearAllClick,
		isFolderSyncSupported,
		isWatching,
		folderName,
		syncedCount,
		startWatching,
		stopWatching
	} = useAssetUploadsBox( { projectID, folderID } );

	return (
		<div className="AssetUploadsBox">
			<Header
				uploadingCount={assetActiveUploadsCount}
				uploadingProgress={totalProgress}
				uploadingETA={totalTimeRemaining}
			/>
			{isWatching && folderName && (
				<WatchingStateSection
					folderName={folderName}
					syncedCount={syncedCount}
					onStopWatching={stopWatching}
				/>
			)}
			{hasUploads ? (
				<UploadsList projectIDs={uploadProjectIDs} />
			) : (
				<EmptyPlaceholder
					canUploadItems={canUploadItems}
					isFolderSyncSupported={isFolderSyncSupported && !isWatching}
					onStartUploadClick={onStartUploadClicked}
					onWatchFolderClick={startWatching}
				/>
			)}
			<Footer
				hasUploads={hasUploads}
				isUploading={isUploading}
				onCancelAllClick={onCancelAllClick}
				onClearAllClick={onClearAllClick}
			/>
		</div>
	);
};

export default AssetUploadsBox;
